<template>
	<a-modal
		title="Vencimientos"
		centered
		wrap-class-name="vencimientosModal"
		:visible="visible"
		width="600px"
		@cancel="$emit('close')"
	>
		<div class="table-responsive mb-0">
			<table class="table table-striped">
				<thead>
					<tr class="font-weight-bold">
						<th class="border-0">
							Fecha del vencimiento
						</th>
						<th
							class="border-0"
							colspan="2"
						>
							Importe
						</th>
					</tr>
				</thead>
				<tbody>
					<tr />
					<template v-for="(item,i) in vencimientos">
						<tr
							v-if="item"
							:key="i"
						>
							<td class="valign-middle">
								<g-field
									v-model="vencimientos[i].VencimientoFecha"
									app="facturas_vencimientos"
									name="VencimientoFecha"
									placeholder="Fecha"
									:clean="true"
								/>
							</td>
							<td class="valign-middle">
								<g-field
									v-model="vencimientos[i].VencimientoImporte"
									app="facturas_vencimientos"
									name="VencimientoImporte"
									placeholder="Importe"
									:clean="true"
								/>
							</td>
							<td class="valign-middle">
								<a-button
									v-show="i > 0"
									type="link"
									@click="removeVencimiento(i)"
								>
									<fa-icon icon="times-circle" />
								</a-button>
							</td>
						</tr>
					</template>
					<tr>
						<td
							colspan="3"
							class="text-center"
						>
							<a-button
								type="dashed"
								class="cursor text-primary"
								@click="addVencimiento"
							>
								<fa-icon
									:icon="['far','plus-square']"
									class="mr-2"
								/>
								Añadir
							</a-button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<template
			slot="footer"
		>
			<div class="d-flex align-items-center">
				<a-tooltip placement="top">
					<template

						slot="title"
					>
						{{ diff.text }}
					</template>
					<h5
						class="mb-0 text-left"
						:class="diff.class"
					>
						Restante: {{ diff.diff | price }}€
					</h5>
				</a-tooltip>

				<div class="ml-auto" />

				<a-button
					type="primary"
					@click="$emit('close')"
				>
					<fa-icon
						icon="save"
						class="mr-2"
					/> Guardar
				</a-button>
			</div>
		</template>
	</a-modal>
</template>

<script>
export default {
	props: {
		value: {
			type: Array,
			required: true
		},
		visible: {
			type: Boolean,
			default: true
		},
		total: {
			type: Number,
			default: 0
		}
	},
	computed: {
		vencimientos: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit('input', val);
			}

		},
		diff() {
			let total = 0;
			for (let i = 0; i < this.vencimientos.length; i += 1) {
				const v = this.vencimientos[i];
				total += v.VencimientoImporte;
			}

			let diff = this.total - total;

			// eslint-disable-next-line no-restricted-globals
			if (isNaN(diff)) diff = 0;

			if (diff === 0) {
				return {
					class: 'text-success',
					text: 'Los importes coinciden',
					total,
					diff
				};
			} if (diff > 0) {
				return {
					class: 'text-danger',
					text: `Faltan ${diff}€ por asignar`,
					total,
					diff
				};
			}
			return {
				class: 'text-danger',
				text: `Sobran ${diff * -1}€ del total de la factura`,
				total,
				diff
			};
		}
	},
	watch: {
		diff(val) {
			if (val.diff === 0) {
				this.$emit('ok');
			} else {
				this.$emit('ko');
			}
		}
	},
	created() {
		if (this.vencimientos.length === 0) this.addVencimiento();
	},
	methods: {
		addVencimiento() {
			this.vencimientos.push({
				VencimientoFecha: null,
				VencimientoImporte: 0
			});
		},
		removeVencimiento(index) {
			this.vencimientos.splice(index, 1);
		}
	}
};
</script>

<style lang="scss">
	.vencimientosModal .ant-modal-body{
		padding: 0;
	}
</style>
